<script>
import { get } from 'lodash'
import { getLogoUrl } from '@theme/components/molecule/Logo/logos'
import SeoMixin from '~/sites/shop/mixins/SeoMixin'

export default {
  extends: SeoMixin,
  methods: {
    getFontsGoogle() {
      return []
    },
    getFontsLocal() {
      // Only the faces that dominate the first viewport; the rest load on demand (font-display: swap),
      // so they do not compete for bandwidth with the LCP resources on mobile
      return [
        { rel: 'preload', href: '/fonts/roboto-regular-webfont.woff2', as: 'font', crossorigin: 'anonymous' },
        { rel: 'preload', href: '/fonts/roboto-bold-webfont.woff2', as: 'font', crossorigin: 'anonymous' },
      ]
    },
    getSeoMetaAttrsCustom(data) {
      return {
        script: [],
      }
    },
    getSeoMetaDescription(data) {
      const content =
        get(this.getPageMetaData(data), 'seo_description') ||
        get(data, 'seo_description') ||
        this.getMetaBySlug('description') ||
        this.getSeoText(get(data, 'description')) ||
        this.getSeoText(get(data, 'perex')) ||
        this.getSeoText(get(data, 'description_short')) ||
        this.getSeoText(get(data, 'description_long')) ||
        this.getFallbackMetaBySlug('description') ||
        this.$store.state.globals.meta.seo_description ||
        ''

      return content
        ? [{ hid: 'description', name: 'description', content }, { property: 'og:description', content }]
        : []
    },
    getSeoText(content) {
      return String(content || '')
        .replace(/<[^>]*>?/gm, '')
        .replace(/\s+/g, ' ')
        .trim()
    },
    getSeoTitle(data) {
      const title =
        get(this.getPageMetaData(data), 'seo_title') ||
        get(data, 'seo_title') ||
        get(data, 'page_meta.seo_title') ||
        this.getMetaBySlug('title') ||
        get(data, 'title') ||
        get(data, 'name') ||
        this.getFallbackMetaBySlug('title')

      return title ? this.seoTitleSuffix(title) : this.$store.state.globals.meta.seo_title || ''
    },
    getStructuredLogoUrl() {
      // Same emitted file as the header logo; may already be absolute when assets are served from a CDN
      const logoUrl = getLogoUrl(this.$i18n.locale || 'cs')

      return /^https?:\/\//.test(logoUrl) ? logoUrl : this.makeAbsoluteUrl(logoUrl)
    },
  },
}
</script>
